/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { InputBase } from '@mui/material';

export const LeftIconWrapper = styled.div`
  cursor: ${({ disabled }) => disabled && 'not-allowed'};
`;

export const RightIconWrap = styled.div`
  display: none;
  align-items: center;
  height: 100%;
  cursor: ${({ disabled }) => disabled && 'not-allowed'};
  :hover {
    svg {
      fill: ${Palette.Primary._400};
    }
  }
`;

export const Container = styled.div`
  position: relative;
  :hover {
    ${RightIconWrap} {
      display: flex;
      position: absolute;
      top: 0;
      right: 12px;
    }
  }
  svg {
    fill: ${() => Palette.PrimaryGray._400};
  }
  cursor: pointer;
  ${LeftIconWrapper} {
    position: absolute;
    top: 10px;
    left: 8px;
  }
`;

export const StyledInputWrapper = styled.div`
  display: flex;
  border-radius: 4px;
  position: relative;

  & div.Mui-disabled {
    opacity: 0.5;
    border: 1px solid ${() => Palette.PrimaryGray._300};
    &:hover {
      border: 1px solid ${() => Palette.PrimaryGray._300};
    }
  }
  & input.Mui-disabled {
    color: ${() => Palette.PrimaryGray._900};
    padding-right: 24px;
  }
  .MuiInputBase-root {
    cursor: pointer;
  }
  input {
    cursor: pointer;
  }
`;

export const StyledInput = styled(InputBase)`
  color: ${() => Palette.PrimaryGray._900};
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  max-height: 40px;
  padding: 12px 16px;
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.04);

  outline: none;
  border: 1px solid ${() => Palette.PrimaryGray._200};
  background: ${() => Palette.PrimaryGray._000};
  transition: 0.2s ease-in-out;
  &::placeholder {
    color: ${() => Palette.PrimaryGray._900};
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
  }
  &:hover {
    border: 1px solid ${() => Palette.PrimaryGray._300};
  }

  input {
    margin-right: ${({ moveinputright }) => moveinputright && `${moveinputright}px`};
    margin-left: ${({ moveinputleft }) => moveinputleft && `${moveinputleft}px`};
    padding: 0;
    color: ${({ message }) => {
      if (message?.startTime === 'false') {
        return Palette.Red._500;
      } else return 'none';
    }};
    &:disabled {
      cursor: not-allowed;
    }
  }

  textarea {
    margin: 0 16px;
  }
  ${({ isopen }) =>
    isopen === 'true' &&
    css`
      border-radius: 4px 0px 0px 4px;
      border: 1px solid ${Palette.Primary._300};
      background: #fff;
      box-shadow: 0px 0px 0px 3px rgba(59, 137, 246, 0.16);
    `}

  ${({ error }) =>
    error &&
    css`
      background: ${() => Palette.PrimaryGray._000};
      border: 1px solid ${() => Palette.Red._300};
      &:hover {
        border: 1px solid ${() => Palette.Red._300};
      }
    `}
`;
